/**
 * @author Antoine Laviron
 * @date 2024-08-27
 *
 * @description
 * This is the primary entry point for the React application. Its main responsibility
 * is to render the root component (`App`) into the DOM. It also sets up the
 * global context providers that need to be available to the entire component tree,
 * such as the ThemeContextProvider.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { ThemeProvider } from './context/ThemeContext'; 

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
